import Vue from 'vue';
import Vuex from 'vuex';

import createLogger from 'vuex/dist/logger';
import auth from './auth.module';
import profile from './profile.module';
import generalStore from './generalStore';
import mainMenu from './mainMenu.module';
import contactForm from './contactForm.module';
import jobsStore from './jobs.module';
import brandStore from './brand.module';
import eventStore from './event.module';
import tmxStores from './tmxStores.module';
import DeviceManagement from "./DeviceManagement";
import GeneralManagement from "./GeneralManagement";
import StoreManagement from "./StoreManagement";
import campaign from './campaign.js';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createLogger()],
  modules: {
    auth,
    profile,
    generalStore,
    mainMenu,
    contactForm,
    jobsStore,
    brandStore,
    eventStore,
    tmxStores,
    DeviceManagement,
    GeneralManagement,
    StoreManagement,
    campaign,
  },
});
